import { useState, cloneElement, ReactElement } from 'react';
import Modal from './Modal';
import Button from './Button';

interface ConfirmDialogProps {
  title: string;
  body: string;
  confirm?: string;
  cancel?: string;
  onConfirm: () => void;
  trigger: ReactElement<{ onClick?: () => void }>;
  destructive?: boolean;
}

const ConfirmDialog = ({
  title,
  body,
  confirm = 'Confirmer',
  cancel = 'Annuler',
  onConfirm,
  trigger,
  destructive = true,
}: ConfirmDialogProps) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <>
      {cloneElement(trigger, { onClick: () => setOpen(true) })}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        size="sm"
        footer={
          <>
            <Button variant="outline" onClick={() => setOpen(false)}>
              {cancel}
            </Button>
            <Button variant={destructive ? 'danger' : 'primary'} onClick={handleConfirm}>
              {confirm}
            </Button>
          </>
        }
      >
        <p className="text-sm text-gray-600 dark:text-gray-300">{body}</p>
      </Modal>
    </>
  );
};

export default ConfirmDialog;
